package com.taocent.simple.compose.component.richtext.core.platform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.PointerEventPass
import androidx.compose.ui.input.pointer.pointerInput

internal object JsRichTextPlatformAdapter : RichTextPlatformAdapter {
    override val supportsSystemContextMenu: Boolean = true
    override val supportsRichClipboard: Boolean = false
    override val supportsImeComposition: Boolean = true
    override val requiresCollapsedCursorContextToolbarToggle: Boolean = false

    /**
     * KMP 1.11.1 web 平台 [androidx.compose.ui.input.pointer.PointerEvent.web.kt]
     * 会把 MouseEvent `button=2`(右键)转成 [androidx.compose.ui.input.pointer.PointerButton.Secondary] 派发,
     * 因此可以用 pointerInput 拦截右键 Press → 调 [onContextMenuRequested] 弹自定义
     * [com.taocent.simple.compose.component.richtext.core.internal.toolbar.FloatingToolbar]。
     *
     * 浏览器原生 contextmenu 已被 `ComposeWindowInternal.web.kt` 在 canvas 级别
     * `preventDefault()` 拦截,本 modifier 是双保险:即便自定义 InteropView 嵌套
     * 绕过了 canvas 级别拦截,TextField 自己的 pointer handler 也会消费右键 Press。
     *
     * 核心派发判断 [isContextMenuTrigger] 抽到 commonMain 顶层纯函数复用。
     */
    @OptIn(ExperimentalComposeUiApi::class)
    override fun Modifier.suppressNativeContextMenu(onContextMenuRequested: () -> Unit): Modifier =
        pointerInput(onContextMenuRequested) {
            awaitPointerEventScope {
                while (true) {
                    val event = awaitPointerEvent(PointerEventPass.Initial)
                    if (isContextMenuTrigger(event)) {
                        event.changes.forEach { it.consume() }
                        onContextMenuRequested()
                    }
                }
            }
        }
}

@Composable
actual fun rememberRichTextPlatformAdapter(): RichTextPlatformAdapter {
    return remember { JsRichTextPlatformAdapter }
}
